import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class SessionsViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);


  async canActivate(): Promise<boolean> {
    const view = this.getView();
    if (view) {
      return await this.routeGuardService.handleRoute(view);
    }
    return true;
  }

  getView(): View {
    return {
      route: 'sessions',
      iframeUrl: 'session/',
    };
  }
}
